import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export const SimpleTable: React.FC<{
  loading: boolean;
  empty: boolean;
  emptyText: string;
  head: string[];
  rows: React.ReactNode[][];
}> = ({ loading, empty, emptyText, head, rows }) => {
  if (loading) return <Skeleton className="h-32 w-full" />;
  if (empty) return <p className="py-8 text-center text-sm text-gray-400">{emptyText}</p>;
  return (
    <div className="overflow-x-auto rounded-lg border border-gray-100">
      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <thead className="bg-gray-50">
          <tr>
            {head.map((h) => (
              <th key={h} className="px-4 py-2.5 text-left text-xs font-medium uppercase tracking-wide text-gray-500">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {rows.map((r, i) => (
            <tr key={i} className="hover:bg-gray-50">
              {r.map((cell, j) => (
                <td key={j} className="px-4 py-2.5 text-gray-700">
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
